import classNames from 'classnames'

import { SortableContextContainerProvider } from '../../../DragDrop'
import { FileUploadConstantInputWrap } from '../../../File'
import { Table } from '../../../Table'
import { QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES } from '../RequestProfileTabActivities.constants'
import { useRequestProfileTabActivitiesTableActions } from '../RequestProfileTabActivities.hooks'
import {
  getActivitiesById,
  getActivityDndId,
  getActivityItemActions,
  getRequestProfileTabActivitiesTableColumns,
  getRequestProfileTabActivitiesTableItems,
} from '../RequestProfileTabActivities.utils'

import { RequestProfileTabActivitiesSortableTableRow } from './RequestProfileTabActivitiesSortableTableRow'

import * as styles from './RequestProfileTabActivitiesPhaseTable.module.css'

function RequestProfileTabActivitiesPhaseTable({
  activities,
  canEditActivities,
  permissions,
  phaseId,
}) {
  const {
    getFileAttachInputProps,
    handleChangeStatus,
    handleChangeVisibility,
    handleClickEmailTag,
    handleClickFileTag,
    handleEditActivity,
    setActivityItemAction,
  } = useRequestProfileTabActivitiesTableActions()

  const columns = getRequestProfileTabActivitiesTableColumns(permissions)

  const itemActions = getActivityItemActions(permissions)

  const items = getRequestProfileTabActivitiesTableItems(activities)

  const activityIds = items.map(item => getActivityDndId(item.id))

  const activitiesById = getActivitiesById(activities)

  const draggableRowClassName = {
    [styles.draggableRow]: canEditActivities,
  }

  function handleRowChangeStatus(id, data) {
    return handleChangeStatus({ activity: activitiesById[id], data, id })
  }

  function handleRowChangeVisibility(id, data) {
    return handleChangeVisibility({ activity: activitiesById[id], data, id })
  }

  // SortableContextContainerProvider stays mounted even for read-only users —
  // every sortable row then passes `disabled: true`, so the provider is inert.
  return items.length > 0 ? (
    <div className={styles.RequestProfileTabActivitiesPhaseTable}>
      <FileUploadConstantInputWrap
        getFileAttachInputProps={getFileAttachInputProps}
      >
        <SortableContextContainerProvider items={activityIds}>
          <Table
            TableRow={RequestProfileTabActivitiesSortableTableRow}
            actionsColumnWidth={0}
            arrowNavigationConfig={{ disabled: true }}
            className={styles.table}
            columns={columns}
            context={QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES}
            headerRowProps={{
              className: classNames(styles.headerRow, draggableRowClassName),
              resizable: false,
            }}
            items={items}
            rowProps={{
              Actions: null,
              actions: itemActions.length > 0 ? itemActions : null,
              canDrag: canEditActivities,
              canEditActivities,
              disabled: !canEditActivities,
              hideCheckbox: true,
              phaseId,
              onCallAction:
                itemActions.length > 0 ? setActivityItemAction : null,
              onChangeStatus: canEditActivities ? handleRowChangeStatus : null,
              onChangeVisibility: canEditActivities
                ? handleRowChangeVisibility
                : null,
              onClick: canEditActivities ? handleEditActivity : null,
              onClickEmailTag: handleClickEmailTag,
              onClickFileTag: handleClickFileTag,
            }}
            tableRowClassName={classNames(styles.row, draggableRowClassName)}
          />
        </SortableContextContainerProvider>
      </FileUploadConstantInputWrap>
    </div>
  ) : null
}

export default RequestProfileTabActivitiesPhaseTable
